import { Component } from '@angular/core';

@Component({
  selector: 'era-pane',
  templateUrl: './pane.component.html',
  styleUrls: ['./pane.component.scss'],
})
export class PaneComponent {}
